const KEY = "fidalis_theme"; // 'light' | 'dark' | 'auto'

export function computeAuto() {
  const h = new Date().getHours();
  return h >= 7 && h < 19 ? "light" : "dark";
}
export function getMode() {
  return localStorage.getItem(KEY) || "auto";
}
export function resolved(mode) {
  return mode === "auto" ? computeAuto() : mode;
}
export function apply(mode) {
  const r = resolved(mode);
  document.documentElement.classList.toggle("dark", r === "dark");
  return r;
}
export function setMode(mode) {
  localStorage.setItem(KEY, mode);
  window.dispatchEvent(new Event("fidalis-theme"));
  return apply(mode);
}
export function initTheme() {
  apply(getMode());
  setInterval(() => {
    if (getMode() === "auto") apply("auto");
  }, 600000);
}
